import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-lesson-categories',
  templateUrl: './lesson-categories.component.html',
  styleUrls: ['./lesson-categories.component.scss']
})
export class LessonCategoriesComponent implements OnInit {
  @Output() buttonSelectEvent = new EventEmitter<any>();
  title: string = '';
  source: string = 'lessonCategories';

  constructor() { }

  ngOnInit(): void {
  }

  returnedSectionTitle(data){
    this.title = data;
  }
}
